export default "__VITE_ASSET__B4nL2DtV__"